export class GeneralViewStateTypes {
    public static SINGLE: number = 0;
    public static MULTIPLE: number = 1;
}

export class ViewStateTypes {
    public static SYSTEM: number = -1;
    public static TOPIC: number = 0;
    public static ASSIGNMENT: number = 1;
    public static SEARCH: number = 2;
    public static SLIDESHOW: number = 3;
    public static SINGLETOPIC: number = 4;

    public static WIRE: number = 200;
    public static WIRESEARCH: number = 201;

    public static SINGLEFEED: number = 202;
    public static MULTIPLEFEED: number = 203;

    public static RSSFEED: number = 204;
    public static TWITTERFEED: number = 205;
    public static WIREFEED: number = 206;
    public static EMAILFEED: number = 207;

    public static DRAFT: number = 300;
    public static DRAFTSEARCH: number = 301;
    public static ROLIST: number = 400;
    public static LIVESEARCH: number = 401;
    public static PUBLICATION: number = 500;
    public static CASTSEARCH: number = 501;
}
